import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const Check3: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='M312.66 628c-4.23 0-8.24-1.82-11.02-5l-21.35-24.4.2.04L175.5 477.86c-8.3-9.55-12.39-21.76-11.51-34.39.44-6.32 2.07-12.32 4.83-17.87L309.7 587.66l258.36-413.38c8.72-13.95 23.76-22.28 40.24-22.28 2.62 0 5.25.22 7.83.66-102.94 165.71-279.61 449.96-292.76 470.55-.63.67-1.08 1.14-1.25 1.3-2.6 2.23-5.98 3.49-9.47 3.49z' />
  </IconBase>
));

Check3.displayName = 'Check3';

export default Check3;
